import React from 'react';
import PropTypes from 'prop-types';

import { InsOutsTitleSection } from './InsOutsTitleSection';
import { InsOutsTeamGrid } from './InsOutsTeamGrid';

/**
 * Renders the wrapper and title for both teams.
 *
 * @param {object} props The Ins/Outs player data and config.
 * @param props.data
 * @param props.title
 * @param props.matchTitle
 * @param props.cssClass
 * @param props.homeTeamId
 * @param props.awayTeamId
 * @param props.isAFLW
 * @returns {React.JSX.Element} The Ins/Outs row for both teams.
 */
export const InsOutsRowBoth = ({
    data,
    title,
    matchTitle,
    cssClass,
    homeTeamId,
    awayTeamId,
    isAFLW = false
}) => {
    return (
        <div className="team-lineups-condensed-embeddable__ins-and-outs team-lineups-condensed-embeddable__ins-and-outs--both">
            <InsOutsTitleSection
                title={title}
                cssClass={cssClass}
                visibilityClass="u-hide-from-tablet"
            />
            <div className="team-lineups__grid">
                <InsOutsTeamGrid
                    players={data.home}
                    side="home"
                    isReversed
                    matchData={data}
                    matchTitle={matchTitle}
                    teamId={homeTeamId}
                    isAFLW={isAFLW}
                />
                <InsOutsTitleSection
                    title={title}
                    cssClass={cssClass}
                    visibilityClass="u-hide-until-tablet"
                />
                <InsOutsTeamGrid
                    players={data.away}
                    side="away"
                    isReversed={false}
                    matchData={data}
                    matchTitle={matchTitle}
                    teamId={awayTeamId}
                    isAFLW={isAFLW}
                />
            </div>
        </div>
    );
};

InsOutsRowBoth.propTypes = {
    data: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired,
    matchTitle: PropTypes.string.isRequired,
    cssClass: PropTypes.string,
    homeTeamId: PropTypes.string,
    awayTeamId: PropTypes.string,
    isAFLW: PropTypes.bool
};
